import { EventLog_BookingKitEventFragment } from "@graphql";
import { BookingKitEventType } from "@bonliva-crm/shared";
import { MainFilterType, FilterType } from "./filter-type";

export const groupEventsByFilterType = (
  events: EventLog_BookingKitEventFragment[]
): Record<FilterType, EventLog_BookingKitEventFragment[]> => {
  const groupedEvents: Record<FilterType, EventLog_BookingKitEventFragment[]> = {
    [MainFilterType.Comment]: [],
    [MainFilterType.SystemLog]: []
  };

  // Iterate through the events array once, classifying each event into the appropriate categories.
  events.forEach((event) => {
    // Check the type of each event and classify it accordingly.
    switch (event.Type) {
      case BookingKitEventType.Comment:
        groupedEvents[MainFilterType.Comment].push(event);
        break;
      default:
        groupedEvents[MainFilterType.SystemLog].push(event);
    }
  });

  return groupedEvents;
};
